import React from "react";
var __jsx = React.createElement;
import Header from "../Header";
import Footer from "../Footer";
import { useWeb3React } from '@web3-react/core';
import { useBreakpoint } from "../../hooks";
import { useModalOpened } from "../../state/application/hooks";
import { ApplicationModal } from "../../state/application/reducer";
import { BestBuyForm, OnboardingChartBox, OrderPreview, OrderStatus, OrderList } from "./components";
import { StyledContainer, StyledMainWrapper, StyledMainContentWrapper, StyledFormsWrapper } from "./styled";

var BestBuy = () => {
  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account;

  var _useBreakpoint = useBreakpoint(),
      isMobile = _useBreakpoint.isMobile;

  var isPreviewOpen = useModalOpened(ApplicationModal.BEST_BUY_ORDER_PREVIEW);
  var showOnboardingChart = !(isPreviewOpen && isMobile);
  var showOrderList = account && !isPreviewOpen;
  return __jsx(StyledContainer, null, __jsx(Header, null), __jsx(StyledMainWrapper, null, __jsx(StyledMainContentWrapper, null, showOnboardingChart && __jsx(OnboardingChartBox, null), __jsx(StyledFormsWrapper, null, __jsx(BestBuyForm, null), __jsx(OrderPreview, null))), __jsx(OrderStatus, null), showOrderList && __jsx(OrderList, null)), __jsx(Footer, null));
};

export default BestBuy;